import React from "react";
import { Routes, Route} from "react-router-dom";
import AdminSignup from "./AdminSignup";
import ResetPassword from "./ResetPassword";
import { Dashboard } from "./Dashboard";
import RequireAuth from "../components/RequireAuth";
import { StudentSignup } from "./StudentSignup";
import { SendOtp } from "./SendOtp";
import VerifyOtp from "./VerifyOtp";
import { Login } from "./Login";
import { Lecture } from "./Lecture";
import StudentLectures from "./StudentLectures";
import AboutLecture from "../components/AboutLecture";
import { LectureDetail } from "./LectureDetail";
import { CreateLecture } from "./CreateLecture";
import { CreateBulkLecture } from "./CreateBulkLecture";
import Bookmark from "./Bookmark";
import { Edit } from './Edit';
import { CopyLecture } from "./Copy";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin-signup" element={<AdminSignup />} />
      <Route path="/student-signup" element={<StudentSignup />} />
      <Route path="/send-otp" element={<SendOtp />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/lecture" element={<RequireAuth><Lecture /></RequireAuth>} />
      <Route path="/lectures" element={<StudentLectures />} />
      <Route path="/lectures/:id" element={<RequireAuth><AboutLecture /></RequireAuth>} />
      <Route path='/create-lecture' element={<CreateLecture />} />
      <Route path='/createbulklecture' element={<CreateBulkLecture />} />
      <Route path='/editLecture/:id' element={<Edit />} />
      <Route path='/copyLecture/:id' element={<CopyLecture />} />
      <Route path="/lecture-detail/:id" element={<LectureDetail />} />
      <Route path='/bookmark' element={<RequireAuth><Bookmark /></RequireAuth>} />
      <Route path="/create-bulk-lecture" element={<CreateBulkLecture />} />
    </Routes>
  );
};

export default MainRoutes;
